import { Component, EventEmitter, inject, Input, Output } from "@angular/core";
import { Cls_MobiAsideMenuItems } from "../models";
import { Router } from "@angular/router";

@Component({
  selector: "mobi-office-lib-aside-section",
  templateUrl: "./aside-section.component.html",
  styleUrls: ["./aside-section.component.scss"],
  standalone: false,
})
export class AsideSectionComponent {
  private readonly router = inject(Router);

  constructor() {}

  @Input() menuItems: Cls_MobiAsideMenuItems[] = [];
  @Input() isExpandable: boolean = true;
  @Input() isLogOutVisible: boolean = false;

  @Output() tabEmitter = new EventEmitter();
  @Output() logoutEmitter = new EventEmitter();

  isExpanded: boolean = true;

  onTabChange(tab: Cls_MobiAsideMenuItems) {
    this.tabEmitter.emit(tab);
  }

  // isActiveRoute(menu: Cls_MobiAsideMenuItems): boolean {
  //   return this.router.url.startsWith(menu.pageUrl || "");
  // }

  isActiveRoute(menu: Cls_MobiAsideMenuItems): boolean {
    return this.router.isActive(menu.pageUrl || "", false);
  }

  onLogout() {
    this.logoutEmitter.emit();
  }

  onExpand() {
    this.isExpanded = !this.isExpanded;
  }
}
